"use client";

import { Switch, Badge, cn } from "@oreme/ui";
import { useAtom } from "jotai";
import React, { type ReactElement, type HTMLAttributes } from "react";
import { ThemeBadge } from "@/components";
import { themeVisibilityAtomFamily } from "@/store/devices";
import { ThemeTypeEnum } from "@/types";
import { cva } from "class-variance-authority";

interface DevicesThemeListItemProps extends HTMLAttributes<HTMLLIElement> {
  label: string;
  type: ThemeTypeEnum;
  count: number;
}

const themeListItemVariants = cva(
  "flex flex-row gap-2 items-center text-xs rounded uppercase font-semibold",
  {
    variants: {
      visible: {
        true: "",
        false: "opacity-20",
      },
    },
    defaultVariants: {
      visible: true,
    },
  },
);

function DevicesThemeListItem({
  className,
  label,
  type,
  count,
}: Readonly<DevicesThemeListItemProps>): ReactElement {
  const [isSelected, setSelected] = useAtom(themeVisibilityAtomFamily(type));

  return (
    <li
      className={cn(
        themeListItemVariants({
          visible: isSelected,
        }),
        className,
      )}
    >
      <ThemeBadge theme={type} />
      {label}

      <div className="ml-auto flex flex-row items-center gap-2">
        <Badge className="ml-auto bg-primary-foreground text-primary-background hover:bg-primary-background">
          {count}
        </Badge>
        <span>
          <Switch checked={isSelected} onCheckedChange={setSelected} />
        </span>
      </div>
    </li>
  );
}

export { DevicesThemeListItem, type DevicesThemeListItemProps };
